import React, { useEffect, useState } from "react";
import { TiTick } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import Hero from "../components/common_components/Hero";
import Halment from "../faetures/Halment";
import badge from "../images/badge-final-2.svg";
import heroImage from "../images/featured/pp.webp";
import Layout from "../layout/Layout";
import { getPricingByPagination } from "../redux/actions/frontendActions/pricingAction";

function Pricing() {
  const dispatch = useDispatch();

  const [fiterState, setFilterState] = useState("");

  const { allpricings } = useSelector((state) => state.Pricing);

  useEffect(() => {
    dispatch(getPricingByPagination());
  }, [dispatch, allpricings]);

  const [Frontselect, setFrontSelect] = useState(true);
  const [Backselect, setBackSelect] = useState(false);
  const [Wpselect, setWpSelect] = useState(false);

  const handleFrontSelect = () => {
    setFrontSelect(true);
    setBackSelect(false);
    setWpSelect(false);
  };
  const handleBackSelect = () => {
    setBackSelect(true);
    setFrontSelect(false);
    setWpSelect(false);
  };
  const handleWPSelect = () => {
    setWpSelect(true);
    setBackSelect(false);
    setFrontSelect(false);
  };





  return (
    <>
     <Halment title="Pricing" />
      <Layout>
        <Hero
          main="Pricing Plan"
          badge={badge}
          heroImage={heroImage}
          smallText="Discover"
          outlineButton="Get in Touch"
          link="/contact"
          description="An aspiring MERN Stack Developer.I lost myself when I dive into the codes. I am a professional web designer and developer.No project is too big or too small for me. Recently I have completed react and node js. I am expertise in Html5, Css3, Javascript, Bootstrap, Jquery, React, Node JS, Express JS,"
        />

        {/* pricing items filter  */}
        <div className="pricing_filter_wrapper padding_container ">
          <div className="top_filter_button_area">
            <div className="button_group">
              <div>
                <NavLink
                  to="#"
                  className={Frontselect ? "select" : "denied"}
                  onClick={handleFrontSelect}
                >
                  <button
                    onClick={() => setFilterState("frontend")}
                    value="frontend"
                  >
                    Frontend
                  </button>
                </NavLink>
              </div>
              <div>
                <NavLink
                  to="#"
                  className={Backselect ? "select" : "denied"}
                  onClick={handleBackSelect}
                >
                  <button
                    onClick={() => setFilterState("fullstack")}
                    value="fullstack"
                  >
                    Full stack
                  </button>
                </NavLink>
              </div>
              <div>
                <NavLink
                  to="#"
                  className={Wpselect ? "select" : "denied"}
                  onClick={handleWPSelect}
                >
                  <button
                    onClick={() => setFilterState("wordpress")}
                    value="wordpress"
                  >
                    Wordpress
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="pricing_card_wrapper">
            {allpricings.length > 0 ? (
              allpricings
                .filter((obj) =>
                  obj.categories.toLowerCase().includes(fiterState)
                )
                .slice(0, 3)
                .map((price, index) => (
                  <div
                    className={
                      price.color === "white" ? "card" : "card  purple"
                    }
                    key={index}
                  >
                   
                    <div className="grade">{price.grade}</div>
                    <div className="top_area">
                      <h4 className="title">{price.title}</h4>
                      <div className="price_in_doller">
                        <div className="icon">$</div>
                        <div className="price">{price.price}</div>
                      </div>
                      <p className="category">Category: {price.categories}</p>
                      <p className="description">{price.description}</p>
                    </div>
                    <div className="features">
                      <ul>
                        {price.features.map((f, i) => (
                          <li key={i}>
                            <TiTick /> <span>{f}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="buy_btn">
                     <Link to={`/price/${price._id}`}>
                     <button >Buy Now</button></Link>
                    </div>
                  </div>
                ))
            ) : (
              <h1>Loading...</h1>
            )}
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Pricing;
